import { TourConfig } from './types';
import { WordEditorWelcomeStepContent } from '@/components/Onboarding/WordEditorWelcomeStepContent';
import { WorkflowGuideStepContent } from '@/components/Onboarding/WorkflowGuideStepContent';
import { createElement } from 'react';

export const wordEditorTour: TourConfig = {
  id: 'word-editor',
  name: 'Word Editor Introduction',
  version: 1,
  context: 'word-editor',
  showProgress: true,
  allowSkip: true,
  type: 'onboarding',

  steps: [
    {
      id: 'welcome',
      target: null,
      title: 'Welcome to GetSign Word Editor!',
      content: createElement(WordEditorWelcomeStepContent),
      placement: 'center',
      size: 'lg',
      disableSpotlight: true,
      showFullNavigation: true,
      nextButtonText: 'Start Tour',
      hideSkipButton: true,
      hideBackButton: true,
    },
    {
      id: 'workflow-guide',
      target: null,
      title: 'Workflow Guidance',
      content: createElement(WorkflowGuideStepContent),
      placement: 'center',
      size: 'xl',
      disableSpotlight: true,
      showFullNavigation: true,
      nextButtonText: 'Next',
    },
    {
      id: 'toolbar',
      target: '[data-tour="word-editor-toolbar"]',
      title: 'Formatting Toolbar',
      content:
        'Use the toolbar to format your document — adjust fonts, alignment, lists, and more. Write your content here before adding board fields or tables.',
      placement: 'bottom',
      spotlightPadding: 4,
    },
    {
      id: 'board-fields',
      target: '[data-tour="word-editor-board-fields"]',
      title: 'Board Fields',
      content:
        'Pull data directly from your monday.com board columns. Click or drag a field to insert it into your document.',
      placement: 'left',
      spotlightPadding: 12,
    },
    {
      id: 'sub-items',
      target: '[data-tour="word-editor-sub-items"]',
      title: 'Tables & Dynamic Content',
      content:
        'Insert Sub Items tables or Connect Board tables to pull related data directly into your document.',
      placement: 'left',
      spotlightPadding: 12,
    },
    {
      id: 'view-guide',
      target: '[data-tour="word-editor-learn-more"]',
      title: 'View the Guide Anytime',
      content:
        'Click here at any time to reopen the Workflow Guidance and review the steps.',
      placement: 'left',
      spotlightPadding: 8,
      nextButtonText: 'Finish',
    },
  ],
};
